"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSelectPlus = _interopRequireDefault(require("react-select-plus"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Dom = require("../utils/Dom");

var _Props = require("../utils/Props");

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _OptionTypes = require("../types/OptionTypes");

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _UITypeaheadResultsItem = _interopRequireDefault(require("../typeahead/results/UITypeaheadResultsItem"));

var _ButtonConstants = require("../button/ButtonConstants");

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UIControlledPopover = _interopRequireDefault(require("../tooltip/UIControlledPopover"));

var _UILoadingSpinner = _interopRequireDefault(require("../loading/UILoadingSpinner"));

var _UISearchInput = _interopRequireDefault(require("../input/UISearchInput"));

var _MultiSelectValue = _interopRequireDefault(require("./utils/MultiSelectValue"));

var _UISelectWithButtonAnchor = _interopRequireDefault(require("./internal/UISelectWithButtonAnchor"));

var _UISelectWithInputAnchor = _interopRequireDefault(require("./internal/UISelectWithInputAnchor"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var customRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _decorators = require("../utils/propTypes/decorators");

var _Tether = require("../constants/Tether");

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _FieldsetContext = require("../context/FieldsetContext");

var Async = _reactSelectPlus.default.Async,
    Creatable = _reactSelectPlus.default.Creatable,
    stripDiacritics = _reactSelectPlus.default.stripDiacritics;
var SELECT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__selectplus--small'
};

var isVirtualized = function isVirtualized(menuRenderer) {
  return menuRenderer && menuRenderer.displayName === 'virtualizedMenuRenderer';
};

var LoadMoreComponent = function LoadMoreComponent(_ref) {
  var options = _ref.options,
      pagination = _ref.pagination;
  return _react.default.createElement("span", null, _react.default.createElement("span", {
    className: "private-form__selectplus--load-more-count"
  }, pagination.length ? _I18n.default.text('salesUI.UISelect.andMore', {
    count: pagination.length - options.length
  }) : ''), _react.default.createElement(_UILink.default, null, _I18n.default.text('salesUI.UISelect.loadMore')));
};

var multiDummyOption;

var getMultiDummyOption = function getMultiDummyOption() {
  multiDummyOption = multiDummyOption || {
    disabled: true,
    dropdownText: _I18n.default.text('salesUI.UISelect.allOptionsSelected'),
    isSpecial: true,
    title: '',
    value: '__MULTI_DUMMY_OPTION__'
  };
  return multiDummyOption;
};

var loadMoreOptionValue = '__LOAD_MORE_OPTION__';

var getLoadMoreOption = function getLoadMoreOption(_ref2) {
  var input = _ref2.input,
      loadMoreComponent = _ref2.loadMoreComponent,
      options = _ref2.options,
      pagination = _ref2.pagination;
  return {
    dropdownClassName: 'private-form__selectplus--load-more',
    dropdownText: customRenderer.render(loadMoreComponent, {
      options: options,
      pagination: pagination
    }),
    input: input,
    isSpecial: true,
    title: '',
    value: loadMoreOptionValue
  };
};

var getIsLoadingOption = function getIsLoadingOption() {
  return {
    disabled: true,
    dropdownClassName: 'private-dropdown__loading',
    dropdownText: _react.default.createElement(_UILoadingSpinner.default, {
      layout: "centered",
      size: "small"
    }),
    isSpecial: true,
    title: '',
    value: '__IS_LOADING_OPTION__'
  };
};

var getInputProps = function getInputProps(autoComplete, disabled, id, searchable, computedAnchorType, handleAutosize, handlePaste, readOnly) {
  if (disabled || !searchable || computedAnchorType !== 'combined' || readOnly) return {};
  return {
    autoComplete: autoComplete,
    id: id,
    onAutosize: handleAutosize,
    onPaste: handlePaste
  };
};
/**
 * @param {Object} option The option to determine the checkbox state for
 * @param {*} value The `value` prop
 * @return {Object} { indeterminate, checked }
 */


var getCheckboxState = function getCheckboxState(option, value) {
  if (option.getCheckboxState) return option.getCheckboxState(option);
  var isOptionGroup = !!option.options;
  var isSelectAll = isOptionGroup && !!option.selectAll;
  var nestedOptionCount = 0;
  var selectedOptionCount = 0;

  if (isSelectAll) {
    var tabulate = function tabulate(o) {
      if (o.options) {
        o.options.forEach(tabulate);
      } else if (!o.disabled) {
        nestedOptionCount += 1;
        if (Array.isArray(value) && value.includes(o.value)) selectedOptionCount += 1;
      }
    };

    tabulate(option);
  }

  var indeterminate = isSelectAll && 0 < selectedOptionCount && selectedOptionCount < nestedOptionCount;
  var checked = isSelectAll ? nestedOptionCount === selectedOptionCount : !!(Array.isArray(value) && value.includes(option.value));
  return {
    indeterminate: indeterminate,
    checked: checked
  };
};

var makeNewOptionsCache = function makeNewOptionsCache(optionsCache, options) {
  var newOptionsCache = (0, _extends2.default)({}, optionsCache);

  var addOptionToCache = function addOptionToCache(option) {
    newOptionsCache[option.value] = option;
  };

  var addOptionListToCache = function addOptionListToCache(optionList) {
    optionList.forEach(function (option) {
      if (Array.isArray(option.options)) {
        addOptionListToCache(option.options);
      } else {
        addOptionToCache(option);
      }
    });
  }; // Recursively add all options, including those within groups, to the cache.


  addOptionListToCache(options);
  return newOptionsCache;
};

function promptTextCreator(label) {
  return _I18n.default.text('salesUI.UISelect.createOption', {
    label: _I18n.default.SafeString(label)
  });
}
/**
 * "Cleans" an input value. Matches the filter react-select-plus applies to the input passed to `loadOptionsProxy`. (#5289)
 */


function filterInputValue(inputValue, _ref3) {
  var _ref3$ignoreAccents = _ref3.ignoreAccents,
      ignoreAccents = _ref3$ignoreAccents === void 0 ? true : _ref3$ignoreAccents,
      _ref3$ignoreCase = _ref3.ignoreCase,
      ignoreCase = _ref3$ignoreCase === void 0 ? true : _ref3$ignoreCase;
  // https://github.com/HubSpot/react-select-plus/blob/8ae7465fc9b6b9600a01e4e23de97f2d403fd139/src/Async.js#L155-L163
  var transformedInputValue = inputValue;

  if (ignoreAccents) {
    transformedInputValue = stripDiacritics(transformedInputValue);
  }

  if (ignoreCase) {
    transformedInputValue = transformedInputValue.toLowerCase();
  }

  return transformedInputValue;
}

var UISelectCore = _react.default.createClass({
  displayName: "UISelectCore",
  propTypes: {
    allowCreate: _propTypes.default.bool,
    anchorType: _propTypes.default.oneOf(['auto', 'button', 'combined', 'input']),
    autoComplete: _propTypes.default.string,
    autoFocus: _propTypes.default.bool,
    autoload: _propTypes.default.bool,
    ButtonContent: _UISelectWithButtonAnchor.default.propTypes.ButtonContent,
    buttonSize: _propTypes.default.oneOf(Object.keys(_ButtonConstants.SIZE_CLASSES)),
    buttonUse: _propTypes.default.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired,
    cache: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
    clearable: _propTypes.default.bool.isRequired,
    closeOnTargetLeave: _propTypes.default.bool,
    delimiter: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    dropdownClassName: _propTypes.default.string,
    dropdownFooter: _propTypes.default.node,
    error: _propTypes.default.bool,
    filterOptions: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
    id: _propTypes.default.string,
    ignoreAccents: (0, _decorators.hidden)(_propTypes.default.bool),
    ignoreCase: (0, _decorators.hidden)(_propTypes.default.bool),
    inputComponent: _propTypes.default.func,
    inputRef: _refObject.default,
    inputValue: _propTypes.default.string,
    isLoading: _propTypes.default.bool,
    itemComponent: _component.default,
    loadMoreComponent: customRenderer.propType,
    loadOptions: _propTypes.default.func,
    menuRenderer: _propTypes.default.func,
    menuWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
    minimumSearchCount: _propTypes.default.number,
    multi: _propTypes.default.bool.isRequired,
    multiCollapseLimit: _propTypes.default.number,
    noResultsText: (0, _createLazyPropType.default)(_propTypes.default.node),
    onChange: _propTypes.default.func,
    onInputKeyDown: _propTypes.default.func,
    onInputChange: _propTypes.default.func,
    onInputValueChange: _propTypes.default.func,
    onOpenChange: _propTypes.default.func,
    onPaste: _propTypes.default.func,
    onSelectedOptionChange: _propTypes.default.func,
    open: _propTypes.default.bool,
    optionComponent: _propTypes.default.func,
    options: _propTypes.default.arrayOf(_OptionTypes.OptionOrGroupType),
    optionRenderer: _propTypes.default.func,
    optionRendererIgnoresSpecialOptions: _propTypes.default.bool,
    placeholder: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
    placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS),
    promptTextCreator: _propTypes.default.func,
    readOnly: _propTypes.default.bool,
    resetValue: _OptionTypes.ValueType,
    resultsClassName: _propTypes.default.string,
    search: _propTypes.default.string,
    searchable: _propTypes.default.bool.isRequired,
    searchClassName: _propTypes.default.string,
    searchPlaceholder: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    searchPromptText: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    splitRegex: _propTypes.default.object,
    tabIndex: _propTypes.default.number,
    value: _OptionTypes.ValueType,
    valueComponent: _component.default,
    valueRenderer: _propTypes.default.func,
    _forcePlaceholder: _propTypes.default.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      allowCreate: false,
      anchorType: 'auto',
      autoload: true,
      buttonSize: 'default',
      buttonUse: 'form',
      clearable: false,
      delimiter: ';',
      open: false,
      ignoreAccents: true,
      ignoreCase: true,
      inputComponent: _UISearchInput.default,
      itemComponent: 'span',
      loadMoreComponent: LoadMoreComponent,
      minimumSearchCount: 8,
      multi: false,
      optionRendererIgnoresSpecialOptions: false,
      placeholder: function placeholder() {
        return _I18n.default.text('salesUI.UISelect.placeholder');
      },
      promptTextCreator: promptTextCreator,
      resetValue: '',
      searchable: true,
      searchPlaceholder: function searchPlaceholder() {
        return _I18n.default.text('salesUI.UISearchableSelectInput.placeholder');
      },
      searchPromptText: function searchPromptText() {
        return _I18n.default.text('salesUI.UISelect.typeToSearch');
      },
      splitRegex: /;/,
      value: '',
      _forcePlaceholder: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      controlWidth: 0,
      inputValue: '',
      isLoading: false,
      optionsCache: {},
      paginationCache: {},
      resetOption: null
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.cacheOptions(this.props);
    this.generateResetOption(this.props);
    this._isMounted = true; // not strictly true, but componentDidMount() fires too late!

    this._getInputProps = (0, _memoizeOne.default)(getInputProps);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    this.cacheOptions(nextProps);
    this.generateResetOption(nextProps);

    if (!this.props.open && nextProps.open) {
      this.resetPaginationCache();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var controlEl = (0, _reactDom.findDOMNode)(this._anchorRef);

    if (!controlEl) {
      return;
    }

    var controlWidth = this.computeControlWidth(controlEl);

    if (controlWidth !== this.state.controlWidth) {
      this.setState({
        controlWidth: controlWidth
      });
    }

    if (!prevProps.open && this.props.open) {
      this.focus();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
  },
  cacheOptions: function cacheOptions(_ref4) {
    var options = _ref4.options;
    // Cache options provided via props (required for certain async scenarios, and for paste handling)
    var optionsCache = this.state.optionsCache;

    if (options) {
      var newOptionsCache = makeNewOptionsCache(optionsCache, options);
      this.setState({
        optionsCache: newOptionsCache
      });
    }
  },
  resetPaginationCache: function resetPaginationCache() {
    // If async caching is disabled, paginationCache should not persist across searches
    var cache = this.props.cache;

    if (cache === null || cache === false) {
      this.setState({
        paginationCache: {}
      });
    }
  },
  generateResetOption: function generateResetOption(_ref5) {
    var placeholder = _ref5.placeholder,
        resetValue = _ref5.resetValue;
    var resetOption = this.state.resetOption;
    var newResetOption = {
      buttonText: (0, _lazyEval.default)(placeholder),
      dropdownText: (0, _lazyEval.default)(placeholder),
      value: resetValue
    };

    if (!(resetOption && resetOption.buttonText === newResetOption.buttonText && resetOption.value === newResetOption.value)) {
      this.setState({
        resetOption: newResetOption
      });
    }
  },
  areOptionsToggleable: function areOptionsToggleable(_ref6) {
    var anchorType = _ref6.anchorType,
        multi = _ref6.multi;
    // Return true if we show options as checkboxes in the dropdown (#1976)
    var computedAnchorType = this.getAnchorType({
      anchorType: anchorType,
      multi: multi
    });
    return multi && computedAnchorType !== 'combined';
  },
  defaultOptionRenderer: function defaultOptionRenderer(option) {
    var _this$props = this.props,
        anchorType = _this$props.anchorType,
        itemComponent = _this$props.itemComponent,
        multi = _this$props.multi,
        optionComponent = _this$props.optionComponent,
        value = _this$props.value;
    var isOptionGroup = !!option.options;
    var isSelectAll = isOptionGroup && !!option.selectAll;
    var toggleable = this.areOptionsToggleable({
      anchorType: anchorType,
      multi: multi
    }) && option.className !== 'Select-create-option-placeholder' && !option.isSpecial && !(isOptionGroup && !isSelectAll);

    var _getCheckboxState = getCheckboxState(option, value),
        indeterminate = _getCheckboxState.indeterminate,
        checked = _getCheckboxState.checked;

    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      itemComponent: optionComponent || itemComponent,
      isIndeterminate: toggleable && indeterminate,
      isSelected: toggleable && checked,
      onToggle: this.handleOptionToggle.bind(this, option),
      option: option,
      style: option.dropdownStyle,
      toggleable: toggleable,
      _useButton: !toggleable
    });
  },
  optionRendererProxy: function optionRendererProxy(option) {
    var _this$props2 = this.props,
        optionRenderer = _this$props2.optionRenderer,
        optionRendererIgnoresSpecialOptions = _this$props2.optionRendererIgnoresSpecialOptions;

    if (optionRenderer == null || option.isSpecial && optionRendererIgnoresSpecialOptions) {
      return this.defaultOptionRenderer(option);
    }

    return optionRenderer(option);
  },
  defaultValueRenderer: function defaultValueRenderer(option) {
    var _this$props3 = this.props,
        itemComponent = _this$props3.itemComponent,
        valueComponent = _this$props3.valueComponent;
    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      "aria-invalid": option.invalid,
      itemComponent: valueComponent || itemComponent,
      key: option.value,
      option: (0, _extends2.default)({}, option, {
        help: undefined
      }),
      _useButton: false,
      _useDropdownText: false
    });
  },
  filterOptionsProxy: function filterOptionsProxy(options, input, excludeOptions) {
    var _this$props4 = this.props,
        anchorType = _this$props4.anchorType,
        clearable = _this$props4.clearable,
        filterOptions = _this$props4.filterOptions,
        ignoreAccents = _this$props4.ignoreAccents,
        ignoreCase = _this$props4.ignoreCase,
        isLoadingProp = _this$props4.isLoading,
        loadMoreComponent = _this$props4.loadMoreComponent,
        multi = _this$props4.multi,
        resetValue = _this$props4.resetValue,
        value = _this$props4.value;
    var _this$state = this.state,
        isLoading = _this$state.isLoading,
        paginationCache = _this$state.paginationCache,
        resetOption = _this$state.resetOption;
    var filterOptionsFunc;

    if (filterOptions === false) {
      filterOptionsFunc = function filterOptionsFunc(x) {
        return x;
      };
    } else if (typeof filterOptions === 'function') {
      filterOptionsFunc = filterOptions;
    } else {
      filterOptionsFunc = this.getDefaultFilterOptionsFunc();
    }

    var showSelectedOptions = this.areOptionsToggleable({
      anchorType: anchorType,
      multi: multi
    });

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var filteredOptions = filterOptionsFunc.apply(void 0, [options, input, showSelectedOptions ? [] : excludeOptions].concat(rest));

    if (input.length === 0) {
      // Add multi dummy option, if needed (#1256)
      if (multi && options.length > 0 && filteredOptions.length === 0) {
        filteredOptions = filteredOptions.concat(getMultiDummyOption());
      } // Add resetOption, if needed (#2300)


      if (clearable && !multi && value != null && value !== resetValue) {
        filteredOptions = [resetOption].concat(filteredOptions);
      }
    }

    if (isLoading || isLoadingProp) {
      // Add "Loading..." option, if needed
      filteredOptions = filteredOptions.concat(getIsLoadingOption());
    } else {
      var paginationCacheKey = filterInputValue(input, {
        ignoreAccents: ignoreAccents,
        ignoreCase: ignoreCase
      });
      var pagination = paginationCache[paginationCacheKey]; // Add "Load more" option, if needed (#2031)

      if (pagination && pagination.hasMore) {
        filteredOptions = filteredOptions.concat(getLoadMoreOption({
          input: input,
          isLoading: isLoading,
          loadMoreComponent: loadMoreComponent,
          options: options,
          pagination: pagination
        }));
      }
    }

    return filteredOptions;
  },
  getDefaultFilterOptionsFunc: function getDefaultFilterOptionsFunc() {
    return _reactSelectPlus.default.defaultProps.filterOptions;
  },
  selectValueProxy: function selectValueProxy(selectValue, selectedOption) {
    // If this is a "Load more" option, trigger load.
    if (selectedOption.value === loadMoreOptionValue) {
      this.triggerLoadMore();
    } // Prevent "special" options from being selected.


    if (selectedOption.isSpecial) {
      return;
    }

    selectValue(selectedOption);
  },
  creatableOnInputChangeProxy: function creatableOnInputChangeProxy(str) {
    var internalCreatableSelect = this.getInternalCreatableSelect();
    var newInputValue = this.handleInputChange(str);
    internalCreatableSelect.inputValue = newInputValue;
    return newInputValue;
  },
  triggerLoadMore: function triggerLoadMore() {
    // Trick Select.Async into calling loadOptions again, then move focus up one option
    var internalSelect = this.getInternalSelect();
    var internalAsyncSelect = this.getInternalAsyncSelect();

    if (!internalSelect || !internalAsyncSelect || !internalAsyncSelect.loadOptions) {
      return;
    }

    var _this$props5 = this.props,
        ignoreAccents = _this$props5.ignoreAccents,
        ignoreCase = _this$props5.ignoreCase;
    var visibleOptions = internalSelect._visibleOptions;
    var loadMoreOption = visibleOptions[visibleOptions.length - 1];
    var transformedInputValue = filterInputValue(loadMoreOption.input, {
      ignoreAccents: ignoreAccents,
      ignoreCase: ignoreCase
    });

    if (internalAsyncSelect._cache) {
      delete internalAsyncSelect._cache[transformedInputValue];
    }

    internalAsyncSelect.loadOptions(transformedInputValue);
    var normalOptions = internalSelect.props.options;
    internalSelect.setState({
      focusedOption: normalOptions[normalOptions.length - 1]
    });
  },
  toggleGroup: function toggleGroup(groupToToggle, willBeSelected) {
    var value = this.props.value;
    var valueCopy = (value || []).slice(0);
    var newValue = valueCopy;

    if (willBeSelected) {
      var addOptionValue = function addOptionValue(o) {
        if (o.options) {
          o.options.filter(function (option) {
            return !option.disabled;
          }).forEach(addOptionValue);
        } else {
          if (newValue.indexOf(o.value) === -1) newValue.push(o.value);
        }
      };

      addOptionValue(groupToToggle);
    } else {
      var removeOptionValue = function removeOptionValue(o) {
        if (o.options) {
          o.options.filter(function (option) {
            return !option.disabled;
          }).forEach(removeOptionValue);
        } else {
          newValue = newValue.filter(function (v) {
            return v !== o.value;
          });
        }
      };

      removeOptionValue(groupToToggle);
    }

    this.setMultiValues(newValue);
  },
  toggleMultiValue: function toggleMultiValue(valueToToggle, willBeSelected) {
    var value = this.props.value;
    var valueCopy = (value || []).slice(0);
    var newValue = null;

    if (willBeSelected) {
      newValue = valueCopy.concat(valueToToggle);
    } else {
      newValue = valueCopy.filter(function (v) {
        return v !== valueToToggle;
      });
    }

    this.setMultiValues(newValue);
  },
  addMultiValues: function addMultiValues(addValues) {
    var value = this.props.value;
    var newValues = (value || []).slice(0);
    addValues.forEach(function (v) {
      if (newValues.indexOf(v) === -1 && v !== '') newValues.push(v);
    });
    this.setMultiValues(newValues);
  },
  setMultiValues: function setMultiValues(newValues) {
    var optionsCache = this.state.optionsCache; // Map values to options

    var newOptions = newValues.map(function (v) {
      return optionsCache[v] || {
        text: v,
        value: v
      };
    });
    this.handleChange(newOptions);
  },
  handleChange: function handleChange(option) {
    // react-select-plus gives us an option object or null, which we pass to
    // onSelectedOptionChange, but our onChange handler expects just the new value.
    var _this$props6 = this.props,
        onChange = _this$props6.onChange,
        onSelectedOptionChange = _this$props6.onSelectedOptionChange,
        value = _this$props6.value;
    (0, _Functions.callIfPossible)(onSelectedOptionChange, (0, _SyntheticEvent.default)(option));
    var newVal = null;

    if (Array.isArray(option)) {
      newVal = option.filter(Boolean).map(function (o) {
        return o.value;
      });
    } else if (option) {
      newVal = option.value;
    }

    if (newVal !== value) {
      onChange((0, _SyntheticEvent.default)(newVal));
    }
  },
  handleInputKeyDown: function handleInputKeyDown(evt) {
    var _this$props7 = this.props,
        anchorType = _this$props7.anchorType,
        multi = _this$props7.multi,
        onInputKeyDown = _this$props7.onInputKeyDown,
        value = _this$props7.value;
    var key = evt.key;
    (0, _Functions.callIfPossible)(onInputKeyDown, evt);

    if (evt.defaultPrevented) {
      return;
    } // In multi-mode, we need to handle ENTER to allow the focused option to be toggled.


    if (key === 'Enter' && multi && this.getAnchorType({
      anchorType: anchorType,
      multi: multi
    }) !== 'combined') {
      var internalSelect = this.getInternalSelect();

      if (!internalSelect) {
        return;
      }

      var focusedOption = internalSelect._focusedOption;

      if (!focusedOption) {
        return;
      }

      if (focusedOption.value === loadMoreOptionValue) {
        this.triggerLoadMore();
        return;
      }

      if (focusedOption.isSpecial || focusedOption.clearableValue === false) {
        return;
      }

      var valueToToggle = focusedOption.value;
      var willBeSelected = value.indexOf(valueToToggle) === -1;
      this.toggleMultiValue(valueToToggle, willBeSelected);
      evt.preventDefault();
    }
  },
  handleOptionToggle: function handleOptionToggle(option, evt) {
    var value = this.props.value;

    if (option.options && option.selectAll) {
      var _getCheckboxState2 = getCheckboxState(option, value),
          checked = _getCheckboxState2.checked,
          indeterminate = _getCheckboxState2.indeterminate;

      this.toggleGroup(option, !checked && !indeterminate);
    } else {
      var valueToToggle = option.value;
      this.toggleMultiValue(valueToToggle, evt.target.checked);
    }
  },
  handleClose: function handleClose(evt) {
    var _this$props8 = this.props,
        onClose = _this$props8.onClose,
        onOpenChange = _this$props8.onOpenChange; // eslint-disable-line react/prop-types

    onOpenChange((0, _SyntheticEvent.default)(false));
    (0, _Functions.callIfPossible)(onClose, evt);
  },
  handleOpen: function handleOpen(evt) {
    var _this$props9 = this.props,
        onOpen = _this$props9.onOpen,
        onOpenChange = _this$props9.onOpenChange; // eslint-disable-line react/prop-types

    onOpenChange((0, _SyntheticEvent.default)(true));
    (0, _Functions.callIfPossible)(onOpen, evt);
  },
  triggerOpen: function triggerOpen() {
    var onOpenChange = this.props.onOpenChange;
    onOpenChange((0, _SyntheticEvent.default)(true));
  },
  handleInputChange: function handleInputChange(str) {
    var _this$props10 = this.props,
        loadOptions = _this$props10.loadOptions,
        multi = _this$props10.multi,
        onInputChange = _this$props10.onInputChange;
    (0, _Functions.callIfPossible)(onInputChange, str);
    this.setState({
      inputValue: str
    }); // Handle typing multi values separated by splitRegex.

    if (multi) {
      var splitValues = this.getSplitValuesFromString(str, false);

      if (splitValues.length > 0) {
        this.addMultiValues(splitValues);
        return '';
      }
    } // If the user typed a request that will hit the cache, ignore any pending request.


    if (loadOptions != null) {
      var internalAsyncSelect = this.getInternalAsyncSelect();

      if (internalAsyncSelect != null) {
        if (internalAsyncSelect._cache && internalAsyncSelect._cache.hasOwnProperty(str)) {
          internalAsyncSelect._callback = null;
          this.setState({
            isLoading: false
          });
        }
      }
    }

    return str;
  },
  handleInputValueChange: function handleInputValueChange(evt) {
    var onInputValueChange = this.props.onInputValueChange;
    (0, _Functions.callIfPossible)(onInputValueChange, evt);
    this.resetPaginationCache();
    this.setState({
      inputValue: evt.target.value
    });
  },
  handlePaste: function handlePaste(evt) {
    var _this$props11 = this.props,
        multi = _this$props11.multi,
        onPaste = _this$props11.onPaste; // Allow developers to override default paste handling.

    (0, _Functions.callIfPossible)(onPaste, evt);

    if (evt.defaultPrevented) {
      return;
    }

    if (!multi) return;
    var clipboardData = evt.clipboardData || window.clipboardData;
    var pastedText = clipboardData.getData('Text');
    var splitValues = this.getSplitValuesFromString(pastedText, true);

    if (splitValues.length > 0) {
      evt.preventDefault();
      this.addMultiValues(splitValues);
    }
  },
  getSplitValuesFromString: function getSplitValuesFromString(str, includeLastValue) {
    var _this$props12 = this.props,
        allowCreate = _this$props12.allowCreate,
        splitRegex = _this$props12.splitRegex;
    var strParts = str.split(splitRegex).map(function (s) {
      return s.trim();
    });

    if (!includeLastValue) {
      strParts = strParts.slice(0, strParts.length - 1);
    }

    if (strParts.length === 0) return []; // Create a map of option labels to options

    var optionsCache = this.state.optionsCache;
    var reverseOptionsCache = {};
    Object.keys(optionsCache).forEach(function (key) {
      var option = optionsCache[key];
      reverseOptionsCache[option.text || key] = option.value;
    }); // For each piece, see if it maps to an option label. If so, add that option's value to
    // the result. Otherwise, if allowCreate is enabled, add a new option.

    var result = [];
    strParts.forEach(function (label) {
      if (reverseOptionsCache.hasOwnProperty(label)) {
        result.push(reverseOptionsCache[label]);
      } else if (allowCreate && result.indexOf(label) === -1) {
        result.push(label);
      }
    });
    return result;
  },
  getMenuWidth: function getMenuWidth() {
    var menuWidth = this.props.menuWidth;

    if (menuWidth === 'auto') {
      return '';
    }

    if (typeof menuWidth === 'number') {
      return menuWidth;
    }

    return Math.max(this.state.controlWidth, _Tether.MIN_MENU_WIDTH);
  },
  computeControlWidth: function computeControlWidth(controlEl) {
    var open = this.props.open;

    if (!controlEl || !open) {
      return 0;
    }

    var exactWidth = controlEl.getBoundingClientRect().width;
    var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
    return roundedWidth - 2; // account for 1px border added by UIPopover
  },
  focus: function focus() {
    try {
      this._anchorRef.focus();
    } catch (e) {
      /* ¯\_(ツ)_/¯ */
    }
  },
  handleAutosize: function handleAutosize() {
    if (this._popover) {
      this._popover.reposition();
    }
  },
  dropdownContentRefCallback: function dropdownContentRefCallback(dropdownEl) {
    if (dropdownEl) {
      dropdownEl.addEventListener('mousedown', this.handleMouseDownOnDropdown);
    }
  },
  anchorRefCallback: function anchorRefCallback(anchorRef) {
    var _this$state2 = this.state,
        controlWidth = _this$state2.controlWidth,
        target = _this$state2.target;
    this._anchorRef = anchorRef;
    var newTarget = (0, _reactDom.findDOMNode)(this._anchorRef);
    var newControlWidth = this.computeControlWidth(newTarget);

    if (target !== newTarget || controlWidth !== newControlWidth) {
      this.setState({
        controlWidth: newControlWidth,
        target: newTarget
      });
    }
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popover = ref;
  },
  selectRefCallback: function selectRefCallback() {
    // Hackily override Select's selectValue and handleMouseDownOnMenu to support "Load more"
    var internalSelect = this.getInternalSelect();
    if (!internalSelect) return;
    internalSelect.selectValue = this.selectValueProxy.bind(this, internalSelect.selectValue);
    var internalCreatableSelect = this.getInternalCreatableSelect();
    if (!internalCreatableSelect) return;
    internalCreatableSelect.onInputChange = this.creatableOnInputChangeProxy;
  },
  getInternalSelect: function getInternalSelect() {
    // Return our react-select Select instance, or null
    if (!this._anchorRef) {
      return null;
    }

    if (this._anchorRef.getInternalSelect) {
      return this._anchorRef.getInternalSelect();
    }

    return this._anchorRef.select || this._anchorRef;
  },
  getInternalCreatableSelect: function getInternalCreatableSelect() {
    // Return our react-select Creatable instance, or null
    if (!this._anchorRef) {
      return null;
    }

    if (this._anchorRef.constructor === Creatable) {
      return this._anchorRef;
    }

    return null;
  },
  getInternalAsyncSelect: function getInternalAsyncSelect() {
    // Return our react-select Async instance, or null
    if (!this._anchorRef) {
      return null;
    }

    if (this._anchorRef.getInternalAsyncSelect) {
      return this._anchorRef.getInternalAsyncSelect();
    }

    if (this._anchorRef.constructor === Async) {
      return this._anchorRef;
    }

    return null;
  },
  handleMouseDownOnDropdown: function handleMouseDownOnDropdown(evt) {
    // react-select-plus normally closes the dropdown and blurs the input on mousedown. We need to
    // prevent that behavior for certain elements.
    var target = evt.target;

    if ((0, _Dom.closest)(target, '.private-dropdown__footer-container')) {
      evt.stopPropagation();
      evt.preventDefault();
      return;
    }

    if ((0, _Dom.closest)(target, '.private-form__selectplus--load-more')) {
      this.triggerLoadMore();
      evt.stopPropagation();
      evt.preventDefault();
      return;
    }

    if ((0, _Dom.closest)(target, '.private-checkbox')) {
      evt.stopPropagation();
      evt.preventDefault();
      return;
    }
  },
  loadOptionsProxy: function loadOptionsProxy(input, loadOptionsCallback) {
    var _this$props13 = this.props,
        open = _this$props13.open,
        loadOptions = _this$props13.loadOptions;

    if (input == null) {
      return;
    } // Show loading indicator until loadOptionsProxyCallback is called


    this.setState({
      isLoading: true
    });
    this._latestSearch = open ? input : null; // Special case: autoload search is designated as null
    // Keep a copy of all options returned by loadOptions

    var paginationCache = this.state.paginationCache;
    var proxyCallback = this.getLoadOptionsProxyCallback(open ? input : null, loadOptionsCallback);
    var result;

    try {
      result = loadOptions(input, proxyCallback, paginationCache[input || '']);
    } catch (error) {
      proxyCallback(error);
      setTimeout(function () {
        throw error;
      }, 0);
    }

    if (result && typeof result.then === 'function') {
      result.then(function (data) {
        proxyCallback(null, data || {});
      }, function (error) {
        proxyCallback(error);
        throw error;
      });
    }
  },
  getLoadOptionsProxyCallback: function getLoadOptionsProxyCallback(input, loadOptionsCallback) {
    var _this = this;

    var proxyCallback = function proxyCallback(error, data) {
      if (!_this._isMounted) return;
      var _this$state3 = _this.state,
          optionsCache = _this$state3.optionsCache,
          paginationCache = _this$state3.paginationCache;
      var newOptionsCache = optionsCache;
      var newPaginationCache = paginationCache; // Cache options so that we can render the selected value properly

      if (data && data.options) {
        newOptionsCache = makeNewOptionsCache(optionsCache, data.options);

        if (data.pagination) {
          newPaginationCache = (0, _extends2.default)({}, paginationCache);
          newPaginationCache[input || ''] = data.pagination;
        }
      }

      var internalAsyncSelect = _this.getInternalAsyncSelect();

      _this.setState({
        isLoading: internalAsyncSelect && internalAsyncSelect._callback != null && _this._latestSearch !== input,
        optionsCache: newOptionsCache,
        paginationCache: newPaginationCache
      });

      for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      loadOptionsCallback.apply(void 0, [error, data].concat(rest));
    };

    return proxyCallback;
  },
  getValueAsObject: function getValueAsObject(value) {
    // In async mode, react-select needs the current value's object form to render it
    var optionsCache = this.state.optionsCache;

    if (!optionsCache) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(function (v) {
        return optionsCache.hasOwnProperty(v) ? optionsCache[v] : v;
      });
    }

    return optionsCache.hasOwnProperty(value) ? optionsCache[value] : value;
  },
  isCollapsed: function isCollapsed(_ref7) {
    var multi = _ref7.multi,
        multiCollapseLimit = _ref7.multiCollapseLimit,
        open = _ref7.open,
        value = _ref7.value;
    return multiCollapseLimit != null && value != null && value.length > multiCollapseLimit && multi && !open;
  },
  getAnchorType: function getAnchorType(_ref8) {
    var anchorType = _ref8.anchorType,
        multi = _ref8.multi;

    if (anchorType === 'auto') {
      return multi ? 'combined' : 'button';
    }

    return anchorType;
  },
  getNoResultsText: function getNoResultsText(_ref9) {
    var noResultsText = _ref9.noResultsText;
    if (noResultsText != null) return (0, _lazyEval.default)(noResultsText);
    var inputValue = this.state.inputValue;
    return inputValue ? _I18n.default.text('salesUI.UISelect.noResults') : _I18n.default.text('salesUI.UISelect.typeToSearch');
  },
  getMenuRenderer: function getMenuRenderer(_ref10) {
    var itemComponent = _ref10.itemComponent,
        menuRenderer = _ref10.menuRenderer,
        menuWidth = _ref10.menuWidth,
        optionRenderer = _ref10.optionRenderer;

    if (isVirtualized(menuRenderer)) {
      if (optionRenderer || itemComponent !== UISelectCore.defaultProps.itemComponent) {
        _devLogger.default.warn({
          message: 'UISelect: virtualize cannot be used with optionRenderer or itemComponent',
          key: 'UISelect: virtualizeCustomRenderer'
        });

        return undefined;
      }

      if (menuWidth === 'auto') {
        _devLogger.default.warn({
          message: 'UISelect: virtualize canot be used with menuWidth="auto"',
          key: 'UISelect: virtualizeAutoWidth'
        });

        return undefined;
      }

      return menuRenderer(this.getMenuWidth());
    }

    return menuRenderer;
  },
  getValueComponent: function getValueComponent(_ref11) {
    var multi = _ref11.multi;
    return multi ? _MultiSelectValue.default : _reactSelectPlus.default.defaultProps.valueComponent;
  },
  renderDropdown: function renderDropdown(props) {
    var _this$props14 = this.props,
        closeOnTargetLeave = _this$props14.closeOnTargetLeave,
        onOpenChange = _this$props14.onOpenChange,
        open = _this$props14.open,
        placement = _this$props14.placement;
    return _react.default.createElement(_UIControlledPopover.default, {
      arrowSize: "none",
      autoPlacement: "vert",
      closeOnTargetLeave: closeOnTargetLeave,
      content: this.renderDropdownContent(props),
      onOpenChange: onOpenChange,
      open: open,
      placement: placement || 'bottom right',
      ref: this.popoverRefCallback,
      target: this.state.target
    });
  },
  renderDropdownContent: function renderDropdownContent(props) {
    var _this$props15 = this.props,
        dropdownClassName = _this$props15.dropdownClassName,
        menuRenderer = _this$props15.menuRenderer,
        resultsClassName = _this$props15.resultsClassName;
    var className = (0, _classnames.default)(dropdownClassName, 'private-dropdown__results', {
      'private-dropdown--virtualized': isVirtualized(menuRenderer)
    });
    return _react.default.createElement("span", {
      className: (0, _classnames.default)('private-typeahead-results', resultsClassName),
      "data-dropdown-results": true
    }, _react.default.createElement("div", {
      className: className,
      ref: this.dropdownContentRefCallback,
      style: {
        width: this.getMenuWidth()
      }
    }, props.children, this.renderDropdownFooter()));
  },
  renderDropdownFooter: function renderDropdownFooter() {
    var dropdownFooter = this.props.dropdownFooter;

    if (!dropdownFooter) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "private-dropdown__footer-container"
    }, dropdownFooter);
  },
  renderCollapsedAnchor: function renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest) {
    var _this2 = this;

    var optionsCache = this.state.optionsCache;
    var renderedValues = value.slice(0, multiCollapseLimit).map(function (v) {
      var option = optionsCache[v] || {
        text: v,
        value: v
      };

      var valueNode = (valueRenderer || _this2.defaultValueRenderer)(option);

      return _react.default.createElement(_MultiSelectValue.default, {
        key: v,
        closeable: false,
        disabled: option.disabled,
        value: option
      }, valueNode);
    });
    var hiddenValueCount = value.length - renderedValues.length;
    var andMoreNode = hiddenValueCount > 0 ? _react.default.createElement(_UIButton.default, {
      "data-hidden-value-count": hiddenValueCount,
      use: "transparent"
    }, _I18n.default.text('salesUI.UISelect.plusMore', {
      count: hiddenValueCount
    })) : null; // We use the same classnames as react-select here, to get the same appearance.

    return _react.default.createElement(_UIClickable.default, (0, _extends2.default)({}, (0, _Props.getAriaAndDataProps)(rest), {
      className: (0, _classnames.default)('Select Select--multi', combinedAnchorClassName),
      "data-collapsed": true,
      onClick: this.triggerOpen,
      onFocus: this.triggerOpen
    }), _react.default.createElement("div", {
      className: "Select-control"
    }, _react.default.createElement("div", {
      className: "Select-multi-value-wrapper"
    }, renderedValues, andMoreNode), _react.default.createElement("div", {
      className: "Select-arrow-zone"
    }, _react.default.createElement("div", {
      className: "Select-arrow"
    }))));
  },
  render: function render() {
    var _this3 = this;

    var _this$props16 = this.props,
        allowCreate = _this$props16.allowCreate,
        anchorType = _this$props16.anchorType,
        autoComplete = _this$props16.autoComplete,
        autoFocus = _this$props16.autoFocus,
        ButtonContent = _this$props16.ButtonContent,
        buttonSize = _this$props16.buttonSize,
        buttonUse = _this$props16.buttonUse,
        className = _this$props16.className,
        clearable = _this$props16.clearable,
        closeOnTargetLeave = _this$props16.closeOnTargetLeave,
        disabled = _this$props16.disabled,
        error = _this$props16.error,
        id = _this$props16.id,
        ignoreAccents = _this$props16.ignoreAccents,
        ignoreCase = _this$props16.ignoreCase,
        inputRef = _this$props16.inputRef,
        inputValue = _this$props16.inputValue,
        isLoading = _this$props16.isLoading,
        itemComponent = _this$props16.itemComponent,
        loadOptions = _this$props16.loadOptions,
        menuRenderer = _this$props16.menuRenderer,
        menuWidth = _this$props16.menuWidth,
        multi = _this$props16.multi,
        multiCollapseLimit = _this$props16.multiCollapseLimit,
        noResultsText = _this$props16.noResultsText,
        __onChange = _this$props16.onChange,
        __onInputValueChange = _this$props16.onInputValueChange,
        onOpenChange = _this$props16.onOpenChange,
        __onSelectedOptionChange = _this$props16.onSelectedOptionChange,
        open = _this$props16.open,
        __optionComponent = _this$props16.optionComponent,
        optionRenderer = _this$props16.optionRenderer,
        options = _this$props16.options,
        placeholder = _this$props16.placeholder,
        readOnly = _this$props16.readOnly,
        resetValue = _this$props16.resetValue,
        searchable = _this$props16.searchable,
        searchClassName = _this$props16.searchClassName,
        searchPlaceholder = _this$props16.searchPlaceholder,
        searchPromptText = _this$props16.searchPromptText,
        __splitRegex = _this$props16.splitRegex,
        tabIndex = _this$props16.tabIndex,
        value = _this$props16.value,
        __valueComponent = _this$props16.valueComponent,
        valueRenderer = _this$props16.valueRenderer,
        rest = (0, _objectWithoutProperties2.default)(_this$props16, ["allowCreate", "anchorType", "autoComplete", "autoFocus", "ButtonContent", "buttonSize", "buttonUse", "className", "clearable", "closeOnTargetLeave", "disabled", "error", "id", "ignoreAccents", "ignoreCase", "inputRef", "inputValue", "isLoading", "itemComponent", "loadOptions", "menuRenderer", "menuWidth", "multi", "multiCollapseLimit", "noResultsText", "onChange", "onInputValueChange", "onOpenChange", "onSelectedOptionChange", "open", "optionComponent", "optionRenderer", "options", "placeholder", "readOnly", "resetValue", "searchable", "searchClassName", "searchPlaceholder", "searchPromptText", "splitRegex", "tabIndex", "value", "valueComponent", "valueRenderer"]);
    var resetOption = this.state.resetOption;
    var combinedAnchorClassName = (0, _classnames.default)(className, 'private-form__selectplus', {
      'private-form__selectplus--multi': multi,
      'private-form__control--error': error,
      // follow convention of disabled className
      'is-readonly': readOnly
    }); // Use an HOC around React Select, if applicable

    var SelectComponent = _reactSelectPlus.default;

    if (loadOptions) {
      SelectComponent = _reactSelectPlus.default.Async;
    } else if (allowCreate) {
      SelectComponent = _reactSelectPlus.default.Creatable;
    } // Use the virtualizedMenuRenderer, if it's provided and compatible with the other props


    var computedMenuRenderer = this.getMenuRenderer({
      itemComponent: itemComponent,
      menuRenderer: menuRenderer,
      menuWidth: menuWidth,
      optionRenderer: optionRenderer
    }); // Determine what type of control the dropdown is attached to

    var computedAnchorType = this.getAnchorType({
      anchorType: anchorType,
      multi: multi
    }); // A null or undefined value should be considered equivalent to resetValue

    var computedValue = value == null ? resetValue : value;

    if (loadOptions && allowCreate) {
      _devLogger.default.warn({
        message: 'UISelect: loadOptions and allowCreate are mutually exclusive.',
        key: 'UISelect: asyncCreatable'
      });
    }

    if (rest.autofocus) {
      _devLogger.default.warn({
        message: "UISelect: The autofocus prop is deprecated in favor of autoFocus to match React's autoFocus prop",
        key: 'UISelect: autofocus'
      });
    }

    if (inputRef && computedAnchorType === 'combined') {
      _devLogger.default.warn({
        message: 'UISelect: The inputRef prop is only supported with anchorType="input" or anchorType="button"',
        key: 'UISelect: inputRef'
      });
    } // We need to attach two ref callbacks to the combined anchor.


    this._refSequence = this._refSequence || (0, _Functions.sequence)(this.anchorRefCallback, this.selectRefCallback); // Bootstrap a read-only state on the "external" Select component by disabling interactivity
    // Only needed for the "combined" anchorType - readOnly class prevents disabled styles from being applied

    var readOnlyProps = readOnly ? {
      disabled: true
    } : {};
    return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref12) {
      var fieldDisabled = _ref12.disabled,
          fieldSize = _ref12.size;
      var computedDisabled = disabled || fieldDisabled; // Props that are used regardless of anchor type

      var commonProps = (0, _extends2.default)({}, rest, {
        backspaceRemoves: multi && computedAnchorType === 'combined',
        clearable: computedAnchorType === 'combined' ? clearable : false,
        disabled: computedDisabled,
        filterOptions: _this3.filterOptionsProxy,
        id: id,
        ignoreAccents: ignoreAccents,
        ignoreCase: ignoreCase,
        inputProps: _this3._getInputProps(autoComplete, computedDisabled, id, searchable, computedAnchorType, _this3.handleAutosize, _this3.handlePaste, readOnly),
        isLoading: isLoading != null ? isLoading : _this3.state.isLoading,
        isOpen: open,
        labelKey: 'text',
        loadOptions: loadOptions ? _this3.loadOptionsProxy : undefined,
        loadingPlaceholder: null,
        menuRenderer: computedMenuRenderer,
        multi: multi,
        noResultsText: _this3.getNoResultsText({
          noResultsText: noResultsText
        }),
        onChange: _this3.handleChange,
        onClose: _this3.handleClose,
        onInputChange: _this3.handleInputChange,
        onInputKeyDown: _this3.handleInputKeyDown,
        onOpen: _this3.handleOpen,
        onPaste: _this3.handlePaste,
        openAfterFocus: true,
        optionRenderer: _this3.optionRendererProxy,
        options: loadOptions ? undefined : options,
        placeholder: (0, _lazyEval.default)(placeholder),
        readOnly: readOnly,
        ref: _this3.anchorRefCallback,
        renderInvalidValues: true,
        required: false,
        resetValue: resetValue,
        searchable: searchable,
        searchPromptText: (0, _lazyEval.default)(searchPromptText),
        tabIndex: tabIndex,
        tabSelectsValue: false,
        value: loadOptions ? _this3.getValueAsObject(computedValue) : computedValue,
        valueComponent: _this3.getValueComponent({
          multi: multi
        }),
        valueRenderer: valueRenderer || _this3.defaultValueRenderer
      });
      var simpleAnchorClassName = (0, _classnames.default)(className, SELECT_SIZE_OPTIONS[fieldSize], {
        'private-form__control--error': error
      });

      if (computedAnchorType === 'input') {
        return _react.default.createElement(_UISelectWithInputAnchor.default, (0, _extends2.default)({}, commonProps, {
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          className: simpleAnchorClassName,
          dropdownComponent: _this3.renderDropdown,
          error: error,
          inputRef: inputRef,
          inputValue: inputValue,
          onInputValueChange: _this3.handleInputValueChange,
          onOpenChange: onOpenChange,
          selectComponent: SelectComponent,
          selectRef: _this3.selectRefCallback
        }));
      }

      if (_this3.isCollapsed({
        multi: multi,
        multiCollapseLimit: multiCollapseLimit,
        open: open,
        value: value
      })) {
        return _this3.renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest);
      }

      if (computedAnchorType === 'button') {
        return _react.default.createElement(_UISelectWithButtonAnchor.default, (0, _extends2.default)({}, commonProps, {
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          buttonSize: buttonSize,
          ButtonContent: ButtonContent,
          buttonUse: buttonUse,
          className: simpleAnchorClassName,
          closeOnTargetLeave: closeOnTargetLeave,
          dropdownContentRef: _this3.dropdownContentRefCallback,
          dropdownFooter: _this3.renderDropdownFooter(),
          error: error,
          inputRef: inputRef,
          menuWidth: menuWidth,
          onInputValueChange: _this3.handleInputValueChange,
          onOpenChange: onOpenChange,
          resetOption: resetOption,
          searchClassName: searchClassName,
          searchPlaceholder: (0, _lazyEval.default)(searchPlaceholder),
          selectComponent: SelectComponent,
          selectRef: _this3.selectRefCallback
        }));
      }

      return _react.default.createElement(SelectComponent, (0, _extends2.default)({
        autofocus: autoFocus
      }, commonProps, {
        className: combinedAnchorClassName,
        dropdownComponent: _this3.renderDropdown,
        ref: _this3._refSequence,
        tabIndex: typeof tabIndex === 'number' ? String(tabIndex) : tabIndex
      }, readOnlyProps));
    });
  }
});

UISelectCore.displayName = 'UISelect';
var UISelect = (0, _Controllable.default)(UISelectCore, ['open', 'value']);
UISelect.stripDiacritics = stripDiacritics;
var _default = UISelect;
exports.default = _default;
module.exports = exports.default;